// extracted by mini-css-extract-plugin
module.exports = {"container":"az_mUb","contentContainer":"az_nUb","linkButton":"az_oUb","heading":"az_pUb","description":"az_qUb"};